'use client';
import ImagePreview from '../ImagePreview';

interface Props {
    content: {
        name: string;
        imageSelection: {
            src: string;
        };
        imageCaption?: { value: string };
    };
}
/** 适用于 pageDetail-Image components */
const PageImage = (props: Props) => {
    // console.log('Image------', props);
    return (
        <div>
            <ImagePreview
                setting={{
                    className: 'w-auto xmd:rounded-[5px]',
                    src: props.content?.imageSelection?.src || '',
                    alt: props.content?.name,
                    rootClassName: 'w-full',
                }}
                canPreview={true}
                mediaOption={{
                    mediaCaption: props.content.imageCaption?.value,
                }}
            />
        </div>
    );
};

export default PageImage;
